import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { categories, mangaSeries } from "@/mocks/manga";

export default function Categories() {
  const latest = [...mangaSeries].sort((a, b) => {
    const da = new Date(a.updateDate).getTime();
    const db = new Date(b.updateDate).getTime();
    return db - da;
  }).slice(0, 6);

  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="主题分类"
          title="按类型找到你的漫画"
          desc="热血、冒险、恋爱、悬疑、玄幻……按分类浏览更多连载漫画，快速定位你的喜好。"
          moreTo="/series"
          moreText="全部作品"
        />

        <div className="grid grid-cols-2 gap-3 sm:grid-cols-4 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.name}
              to={`/series?category=${encodeURIComponent(cat.name)}`}
              className="group flex items-center gap-3 rounded-xl border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-primary-50"
            >
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${cat.icon} text-xl`}></i>
              </span>
              <span className="min-w-0">
                <span className="block truncate text-sm font-bold text-foreground-900">
                  {cat.name}
                </span>
                <span className="block text-xs text-foreground-500">{cat.count} 部作品</span>
              </span>
            </Link>
          ))}
        </div>

        <div className="mt-16 grid gap-10 lg:grid-cols-5">
          <div className="lg:col-span-3">
            <h3 className="mb-5 flex items-center gap-2 font-display text-xl text-foreground-900">
              <i className="ri-time-line text-primary-500"></i>
              最新话动态
            </h3>
            <div className="flex flex-col gap-3">
              {latest.map((m) => (
                <Link
                  key={m.id}
                  to={`/series/${m.id}`}
                  className="group flex items-center gap-4 rounded-xl border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300"
                >
                  <img
                    src={m.cover}
                    alt={`${m.title} 最新话`}
                    className="h-16 w-12 shrink-0 rounded-md object-cover object-top"
                  />
                  <div className="min-w-0 flex-1">
                    <p className="truncate text-sm font-bold text-foreground-900 group-hover:text-primary-600">
                      {m.title}
                    </p>
                    <p className="mt-1 truncate text-xs text-primary-600">{m.lastChapter}</p>
                    <p className="mt-0.5 text-xs text-foreground-500">更新于 {m.updateDate}</p>
                  </div>
                  <span className="shrink-0 rounded-full bg-accent-100 px-2.5 py-1 text-xs text-accent-800">
                    {m.isToday || m.isNew ? "今日" : "更新"}
                  </span>
                </Link>
              ))}
            </div>
          </div>

          <div className="lg:col-span-2">
            <h3 className="mb-5 flex items-center gap-2 font-display text-xl text-foreground-900">
              <i className="ri-bar-chart-2-line text-accent-600"></i>
              本周追更 TOP 3
            </h3>
            <div className="flex flex-col gap-3">
              {hotRank().map((m, i) => (
                <Link
                  key={m.id}
                  to={`/series/${m.id}`}
                  className="group relative overflow-hidden rounded-xl border border-background-200 bg-background-50 p-4 transition-colors hover:border-accent-300"
                >
                  <div className="flex items-center gap-3">
                    <span
                      className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full font-display text-base ${
                        i === 0
                          ? "bg-accent-500 text-background-50"
                          : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      {i + 1}
                    </span>
                    <div className="min-w-0 flex-1">
                      <p className="truncate text-sm font-bold text-foreground-900">{m.title}</p>
                      <p className="truncate text-xs text-foreground-500">{m.category} · {m.lastChapter}</p>
                    </div>
                    <span className="flex shrink-0 items-center gap-1 text-sm text-accent-700">
                      <i className="ri-star-fill"></i>
                      {m.rating.toFixed(1)}
                    </span>
                  </div>
                  <div className="mt-3 h-1.5 overflow-hidden rounded-full bg-background-200">
                    <div className="h-full rounded-full bg-accent-500" style={{ width: `${m.progress}%` }}></div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function hotRank() {
  return [...mangaSeries].sort((a, b) => b.rating - a.rating).slice(0, 3);
}